// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2Mu9p","obliqueLineWrap":"membershipbadge_obliqueLineWrap__pedNq","obliqueLine":"membershipbadge_obliqueLine__YBPzO"};